import React, { Component } from 'react'
import type { PlaylistId } from 'types/playlist'
import api from '@disco/api/server'
import Row from 'components/common/row'
import DialogFooter from 'components/modals/dialog-footer'
import Alert from 'components/ui/alert'
import CopyUrlItem from 'components/ui/copy-url-item'
export default class CopyUrlTab extends Component<
  {
    onClose: (...args: Array<any>) => any
    publicUrl: string
    internalUrl: string
    zipUrl: string | null | undefined
    sendMixpanelEvent: (...args: Array<any>) => any
    playlistId: PlaylistId
    playlistName?: string | null | undefined
    watermark: boolean | null | undefined
    watermarkingStatus: string | null | undefined
    downloadsDisabledDueTo: string | null | undefined
  },
  {
    publicPlaylistUrlError: boolean
  }
> {
  state: {
    publicPlaylistUrlError: boolean
  } = {
    publicPlaylistUrlError: false,
  }
  _handleCopyPublicUrl: () => void = () => {
    this.props.sendMixpanelEvent('Copy URL tab - Copy public playlist URL', {
      Url: this.props.publicUrl,
    })
  }
  _handlePreviewPublicUrl: () => void = () => {
    this.props.sendMixpanelEvent('Copy URL tab - Open public playlist URL', {
      Url: this.props.publicUrl,
    })
  }
  _handleCopyInternalUrl: () => void = () => {
    this.props.sendMixpanelEvent('Copy URL tab - Copy internal playlist URL', {
      Url: this.props.internalUrl,
    })
  }
  _handlePreviewInternalUrl: () => void = () => {
    this.props.sendMixpanelEvent('Copy URL tab - Open internal playlist URL', {
      Url: this.props.internalUrl,
    })
  }
  _handleCopyDownloadUrl: () => void = () => {
    this.props.sendMixpanelEvent('Copy URL tab - Copy direct download URL', {
      Url: this.props.zipUrl,
    })
  }
  _handlePreviewDownloadUrl: () => void = () => {
    this.props.sendMixpanelEvent('Copy URL tab - Open direct download URL', {
      Url: this.props.zipUrl,
    })
  }
  _onPublicUrlQrAction = (action: 'download' | 'copy') => {
    this.props.sendMixpanelEvent('Copy URL tab - Copy public playlist URL', {
      Url: this.props.publicUrl,
      Via: 'QR',
      Action: action,
    })
  }
  _onDownloadUrlQrAction = (action: 'download' | 'copy') => {
    this.props.sendMixpanelEvent('Copy URL tab - Copy direct download URL', {
      Url: this.props.zipUrl,
      Via: 'QR',
      Action: action,
    })
  }

  async componentDidMount() {
    try {
      await api.playlistImplicitShare(this.props.playlistId)
    } catch (error) {
      this.setState({
        publicPlaylistUrlError: true,
      })
    }
  }

  render(): React.ReactElement<'div'> {
    const { downloadsDisabledDueTo } = this.props
    return (
      <div>
        {this.props.watermark && (
          <Row columnsSize={[12]} marginBottom="small">
            <div>
              <Alert status="warning" icon="warning">
                Watermarked tracks downloaded from public share links will not
                be traceable to individual recipients.
              </Alert>
            </div>
          </Row>
        )}
        {!this.props.watermark &&
          this.props.watermarkingStatus === 'not_watermarked' && (
            <Row columnsSize={[12]} marginBottom="small">
              <div>
                <Alert status="warning" icon="warning">
                  This playlist contains a track watermarked in another
                  playlist, but this playlist is not watermarked, so the track
                  won’t be watermarked for recipients of this list.
                </Alert>
              </div>
            </Row>
          )}

        {this.state.publicPlaylistUrlError && (
          <Row columnsSize={[12]} marginBottom="small">
            <div>
              <Alert status="warning" icon="warning">
                Public playlist URL is temporarily unavailable
              </Alert>
            </div>
          </Row>
        )}

        <Row columnsSize={[12]} marginBottom="small">
          <div>
            <CopyUrlItem
              disabled={this.state.publicPlaylistUrlError}
              label="Playlist URL"
              tooltipId="tooltip_share_public_url"
              url={
                !this.state.publicPlaylistUrlError ? this.props.publicUrl : ''
              }
              onCopy={this._handleCopyPublicUrl}
              onPreview={this._handlePreviewPublicUrl}
              qrFilename={`${
                this.props.playlistName ? this.props.playlistName : 'playlist'
              }-qr`}
              enableQR
              onQrAction={this._onPublicUrlQrAction}
            />
          </div>
        </Row>
        <Row columnsSize={[12]} marginBottom="small">
          <div>
            <CopyUrlItem
              label="Internal playlist URL"
              tooltipId="tooltip_share_internal_url"
              url={this.props.internalUrl}
              onCopy={this._handleCopyInternalUrl}
              onPreview={this._handlePreviewInternalUrl}
            />
          </div>
        </Row>
        {this.props.zipUrl && (
          <Row columnsSize={[12]} marginBottom="small">
            <div>
              <CopyUrlItem
                disabled={Boolean(downloadsDisabledDueTo)}
                label="Direct Download URL"
                tooltipId="tooltip_share_direct_url"
                url={downloadsDisabledDueTo || this.props.zipUrl || ''}
                onCopy={this._handleCopyDownloadUrl}
                onPreview={this._handlePreviewDownloadUrl}
                qrFilename={`${
                  this.props.playlistName ? this.props.playlistName : 'playlist'
                }-download-qr`}
                enableQR
                onQrAction={this._onDownloadUrlQrAction}
              />
            </div>
          </Row>
        )}
        <DialogFooter onClose={this.props.onClose} />
      </div>
    )
  }
}
